export const SEGMENT_COLORS = {
  Champions: "#1a6ef5",
  "Loyal Customers": "#0f9d58",
  Promising: "#7c3aed",
  "Need Attention": "#d97706",
  "At Risk": "#ef4444",
  Lost: "#64748b",
};

export const SEGMENT_DISPLAY_NAMES = {
  Champions: "Champion",
  "Loyal Customers": "Loyal",
};

export function getSegmentDisplayName(segmentName) {
  return SEGMENT_DISPLAY_NAMES[segmentName] || segmentName;
}

export const SCORE_COLORS = {
  1: "#e11d48",
  2: "#f97316",
  3: "#eab308",
  4: "#0ea5e9",
  5: "#16a34a",
};
